// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"d79e9a7b","998":"7c6d42e8"}[chunkId] + ".chunk.css";
};